module.exports = __webpack_public_path__ + "static/media/cover-green-tea.88825317.png";